import * as DOMPurify from 'dompurify';

export const sanitize = (body) =>
  DOMPurify.sanitize(body, { FORBID_TAGS: ['script'] });
